export const API_BASE_URL = 'https://example.com/api'; // Ganti dengan URL API backend
